'use strict';

const _=require('pulsar-utils/dist-es6/_');
const d3=require('d3');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const TimeSeries=require('pulsar-dashboard-core/dist-es6/utilities/timeSeries');let

FatigueAlertPlotterDirective=class FatigueAlertPlotterDirective extends BaseControllerBackedDirective{
get objectBindings(){
return['points','threshold','ceiling','plotArea','verticalAxis','horizontalAxis','strokeWidth','offsetTop'];
}
get textBindings(){
return['class','mask'];
}

get controller(){
return FatigueAlertPlotterController;
}};let


FatigueAlertPlotterController=class FatigueAlertPlotterController{
static get $inject(){
return['$scope'];
}

constructor($scope){
this._overThresholdPoints=null;

$scope.$watch('controller.plotArea',()=>{
if(_.exists(this.plotArea)){
this.plotArea.registerPlotter(this);
}
});
}

get _scalesValid(){
return(
_.exists(this.horizontalAxis)&&
_.exists(this.horizontalAxis.scale)&&
_.exists(this.verticalAxis)&&
_.exists(this.verticalAxis.scale));
}

redraw(){
if(!this._scalesValid){
return;
}

const halfStrokeWidth=this.strokeWidth/2;
const verticalOffset=!_.exists(this.offsetTop)?
halfStrokeWidth:
Math.max(this.offsetTop-halfStrokeWidth,halfStrokeWidth);

if(!_.exists(this._overThresholdPoints)){
const{top}=TimeSeries.splitAroundThresholdWithInterpolation(this.points,this.threshold);
this._overThresholdPoints=top;
}

let line=d3.svg.line().
x(point=>this.horizontalAxis.scale(point.time)).
y(point=>verticalOffset).
interpolate('linear').
defined(point=>!isNaN(point.value));

let group=
d3.select(this.plotArea.svgElement).
insert('g','.sleep').
attr({
class:`${this.class} alert`,
mask:`url(#${this.mask}-${this.plotArea.id})`});


group.append('rect').attr({

height:'100%',
width:'100%',
fill:'none'});


group.append('path').attr({
fill:'none',
"stroke-width":this.strokeWidth,
d:line(this._overThresholdPoints)});

}};


module.exports=FatigueAlertPlotterDirective;
//# sourceMappingURL=fatigueAlertPlotterDirective.js.map
